import { render, staticRenderFns } from "./FlowShowView.vue?vue&type=template&id=13ac5cc2&scoped=true&"
import script from "./FlowShowView.vue?vue&type=script&lang=js&"
export * from "./FlowShowView.vue?vue&type=script&lang=js&"
import style0 from "./FlowShowView.vue?vue&type=style&index=0&id=13ac5cc2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ac5cc2",
  null
  
)

export default component.exports